import { StreamsState, RootState } from '../types'
import store, { moduleActionContext } from '..'
import { cloneDeep } from 'lodash'
import fb from '@/firebase'
import Vue from 'vue'
import { ActionContext } from 'vuex'
import { SourceStream, StreamType, talkbackTargetType, CastStream } from '@/types/streams'
import { CollectionNames, KeyDict } from '@/types'

type StreamsContext = ActionContext<StreamsState, RootState>

const state = {
  castStreams: {},
  talkbackTargetFallback: talkbackTargetType.NONE,
  talkbackTargetCaster: talkbackTargetType.NONE
} as StreamsState

const getters = {}

const actions = {
  setStreamManager (context: StreamsContext, payload: KeyDict<CastStream>) {
    const { commit } = streamsModuleActionContext(context)
    commit.addToStreamsManager(payload)
  },
  setTalkbackFallback (context: StreamsContext, payload: string) {
    const { commit } = streamsModuleActionContext(context)
    commit.setTalkbackTargetFallback(payload)
  },
  async setTalkbackTarget (context: StreamsContext, payload: string) {
    const { commit } = streamsModuleActionContext(context)
    const target = payload || talkbackTargetType.NONE
    const currentUserId = store.state.user.id || ''
    const currentCasterStreamId = store.state.events.currentCasterStream

    console.log('currentUserId ', currentUserId)
    console.log('currentCasterStream ', currentCasterStreamId)

    if (!currentCasterStreamId) {
      console.warn('No currentCasterStream');
      return
    }

    await fb.db.collection(CollectionNames.STREAMS)
      .doc(currentCasterStreamId)
      .set({ talkbackTarget: target }, { merge: true })

    commit.setTalkbackTarget(target)
  },
  deleteStreamFromManager (context: StreamsContext, payload: string) {
    const { commit } = streamsModuleActionContext(context)
    commit.deleteStreamFromManager(payload)
  },
  async copyCasterToBroadcast (_context: StreamsContext, streamId: string) {
    const mainStreamId = streamId.split('_')[0]
    const origStream = store.state.events.currentCast.source_streams[mainStreamId]
    if (origStream === undefined) {
      throw new Error('Could not find sourcestream with id ' + mainStreamId)
    }
    const sourceStream: Partial<SourceStream> = cloneDeep(origStream)
    const userId = sourceStream.user_id ?? ''
    const user = store.state.team.currentTeam.find(user => user.id === userId)
    sourceStream.type = StreamType.Broadcast
    if (sourceStream.cef_feed_id) {
      delete sourceStream.cef_feed_id
    }
    const stream = await fb.db.collection(CollectionNames.STREAMS).doc(mainStreamId).get()
    const streamData = stream.data()
    if (streamData === undefined) {
      throw Error('caster stream does not exists')
    }
    if (streamData.variants) {
      delete streamData.variants
    }
    streamData.type = 'broadcast'
    streamData.name = user?.display_name ?? user?.first_name ?? 'Caster'
    streamData.cast = store.state.events.currentCast.id
    streamData.deleted = false
    const newStreamId = `${mainStreamId}broadcast`
    await fb.db.collection(CollectionNames.STREAMS).doc(newStreamId).set(streamData)
    await fb.db.collection(CollectionNames.CASTS).doc(store.state.events.currentCast.id).set({
      source_streams: {
        [newStreamId]: sourceStream
      }
    }, { merge: true })
  },
  async clearStreamAuthError (_context: StreamsContext, streamId: string) {
    if (streamId === '') throw Error('empty stream id')
    const fieldPath = new fb.firebase.firestore.FieldPath('auth_info', 'error')
    await fb.db.collection(CollectionNames.STREAMS).doc(streamId).update(fieldPath, fb.firebase.firestore.FieldValue.delete())
  }
}

const mutations = {
  addToStreamsManager (state: StreamsState, payload: KeyDict<CastStream>) {
    state.castStreams = payload
  },
  setTalkbackTarget (state: StreamsState, payload: string) {
    // string id (= target caster) or NONE (= no target)
    state.talkbackTargetCaster = payload
  },
  setTalkbackTargetFallback (state: StreamsState, payload: string) {
    state.talkbackTargetFallback = payload
  },
  deleteStreamFromManager (state: StreamsState, payload: string) {
    Vue.delete(state.castStreams, payload)
  }
}

const streamsModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
} as const

export default streamsModule

export const streamsModuleActionContext = context => moduleActionContext(context, streamsModule)
